'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function HowToController() {
	'ngInject';

	// const vm = this;
}

exports['default'] = HowToController;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/public/main/how-to/how-to.controller.js
 **/